import * as Icons from "react-bootstrap-icons";
import * as mIcons from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const Icon = ({ icon, isReactIcon = false, ...rest }) => {
    const [translate] = useTranslation();

    let Component;
    if (mIcons[icon] && !isReactIcon) {
        Component = mIcons[icon];
    }
    else if (Icons[icon]) {
        Component = Icons[icon];
    }

    if (Component) {
        return <Component {...rest} />;
    }
    else {
        throw new Error(translate("OTM_ICON_NOT_FOUND", { icon: icon }));
    }
};

export default Icon;